import { Loading } from "App"
import RequireRoutePermit from "RequireRoutePermit"
import React, { Suspense } from "react"
import { Route } from "react-router-dom"
import PaybandSummaryPreviewPage from "./report-previews/PaybandSummaryPreview"

const PayrollSummaryPreview = React.lazy(
  () => import("./report-previews/PayrollSummaryPreview")
)
const PayrollJournalPreview = React.lazy(
  () => import("./report-previews/PayrollJournalPreview")
)
const ConsolidatedPayrollJournalPreview = React.lazy(
  () => import("./report-previews/ConsolidatedPayrollJournal")
)
const PayrollVariancePreview = React.lazy(
  () => import("./report-previews/PayrollVariancePreview")
)
const StatutoryBenefitsPreview = React.lazy(
  () => import("./report-previews/StatutoryBenefitsPreview")
)
const YearToDatePreview = React.lazy(
  () => import("./report-previews/YearToDatePreview")
)
const EditBuilder = React.lazy(
  () => import("./report-previews/EditEmployeeReportBuilder")
)
const EmployeeRequestPreview = React.lazy(
  () => import("./report-previews/EmployeeRequestPreview")
)
const CustomBenefitsPreview = React.lazy(
  () => import("./report-previews/CustomBenefitsPreview")
)
const PayrollChangePreview = React.lazy(
  () => import("./report-previews/PayrollChangesReport")
)

const PayrollExemptionPreview = React.lazy(
  () => import("./report-previews/PayrollExemptionsPreview")
)
const PaygradeSummaryPreviewPage = React.lazy(
  () => import("./report-previews/PaygradeSummaryPreview")
)
const LeaveBalancePreviewPage = React.lazy(
  () => import("./report-previews/LeaveBalancesPreview")
)
const CustomFieldsPreviewPage = React.lazy(
  () => import("./report-previews/CustomFieldsPreviewPage")
)
const EmployeeSummaryPreviewPage = React.lazy(
  () => import("./report-previews/EmployeeSummaryPreviewPage")
)

const reportPermission = {
  can_view_reports: "can_view_reports",
  can_view_custom_reports: "can_view_custom_reports",
  can_view_payroll_reports: "can_view_payroll_reports",
  can_view_employee_reports: "can_view_employee_reports",
}
const payrollReport = [
  reportPermission.can_view_payroll_reports,
  reportPermission.can_view_reports,
]
const employeeReportPermission = [
  reportPermission.can_view_employee_reports,
  reportPermission.can_view_reports,
]
const customReportPermission = [
  reportPermission.can_view_custom_reports,
  reportPermission.can_view_reports,
]

export const ReportRoutes = () => {
  return (
    <Route path="report-preview">
      <Route
        path="payroll-summary"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PayrollSummaryPreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="payroll-variance"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PayrollVariancePreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="statutory-benefits"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <StatutoryBenefitsPreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="ytd"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <YearToDatePreview />
          </RequireRoutePermit>
        }
      />

      <Route
        path="payroll-journal"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PayrollJournalPreview />
          </RequireRoutePermit>
        }
      />

      <Route
        path="consolidated-payroll-journal"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <ConsolidatedPayrollJournalPreview />
          </RequireRoutePermit>
        }
      />

      <Route
        path="employee_request"
        element={
          <RequireRoutePermit allowedPermissions={employeeReportPermission}>
            <EmployeeRequestPreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="custom-benefits"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <CustomBenefitsPreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="payroll-changes"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PayrollChangePreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="payroll-exemption"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PayrollExemptionPreview />
          </RequireRoutePermit>
        }
      />
      <Route
        path="paygrade-summary"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PaygradeSummaryPreviewPage />
          </RequireRoutePermit>
        }
      />
      <Route
        path="payband-summary"
        element={
          <RequireRoutePermit allowedPermissions={payrollReport}>
            <PaybandSummaryPreviewPage />
          </RequireRoutePermit>
        }
      />
      <Route
        path="leave-balances"
        element={
          <RequireRoutePermit allowedPermissions={employeeReportPermission}>
            <LeaveBalancePreviewPage />
          </RequireRoutePermit>
        }
      />
      <Route
        path="custom-fields"
        element={
          <RequireRoutePermit allowedPermissions={employeeReportPermission}>
            <CustomFieldsPreviewPage />
          </RequireRoutePermit>
        }
      />
      <Route
        path="employee-summary"
        element={
          <RequireRoutePermit allowedPermissions={employeeReportPermission}>
            <EmployeeSummaryPreviewPage />
          </RequireRoutePermit>
        }
      />
      <Route
        path="builder/:x/:id"
        element={
          <RequireRoutePermit allowedPermissions={customReportPermission}>
            <EditBuilder />
          </RequireRoutePermit>
        }
      />
    </Route>
  )
}
